import { RepositoryGetFunctionArgs, RepositorySaveFunctionArgs } from "@lookiero/messaging";
import { HttpPostFunction } from "@lookiero/sty-psp-http";
import { GamesGetFunction, GamesSaveFunction } from "../../../../domain/game/model/games";
import { httpGamesPlay } from "./httpGamesPlay";

interface HttpGamesGetFunctionArgs extends RepositoryGetFunctionArgs {}

interface HttpGamesGetFunction extends GamesGetFunction<HttpGamesGetFunctionArgs> {}

const getGame: HttpGamesGetFunction = () => async () => {
  throw new Error("Game not found");
};

interface HttpGamesSaveFunctionArgs extends RepositorySaveFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpGamesSaveFunction extends GamesSaveFunction<HttpGamesSaveFunctionArgs> {}

const saveGame: HttpGamesSaveFunction =
  ({ httpPost }) =>
  async (aggregateRoot) => {
    await httpGamesPlay({ httpPost })(aggregateRoot);
  };

export type { HttpGamesSaveFunction };
export { getGame, saveGame };
